<template>
  <v-card class="px-5 py-3 brt-15 w-100" elevation="0">
    <v-row>
      <v-col class="flex-grow-1">
        <v-toolbar-title class="page-title">
          {{ titulo }}
        </v-toolbar-title>
      </v-col>
      <v-col>
        <v-text-field
          class="input-button input-cinza"
          label="Pesquisar"
          :value="pesquisa"
          @input="onPesquisar"
          outlined
          dense
          hide-details
        >
          <template>
            <v-icon slot="append" color="white">mdi-magnify</v-icon>
          </template>
        </v-text-field>
      </v-col>
      <div class="d-flex py-3 px-4">
        <v-btn 
          class="new-button" 
          color="primary" 
          :disabled="disableExportar"
          @click="onExportar"
        >
          <v-icon left>mdi-microsoft-excel</v-icon> Exportar
        </v-btn>
        <v-btn
          class="ml-5 new-button"
          color="primary"
          :disabled="disableImportar"
          @click="onImportar"
        >
          <v-icon left>mdi-upload</v-icon> 
          Importar
        </v-btn>
        <v-btn 
          class="ml-5 new-button" 
          color="primary" 
          :disabled="disableCadastrar"
          @click="onCadastrar"
          v-if="!hideCadastrar"
        >
          <v-icon left>mdi-plus-thick</v-icon> 
          Cadastrar
        </v-btn>
      </div>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'HeaderListaPlanejamentoEcomm',
  props: {
    titulo: {
      type: String,
      default: 'Vínculo plano x fornecedor'
    },
    pesquisa: {
      type: String,
      default: ''
    },
    disableCadastrar: {
      type: Boolean,
      default: false
    },
    disableExportar: {
      type: Boolean,
      default: false
    },
    disableImportar: {
      type: Boolean,
      default: false
    },
    hideCadastrar: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onPesquisar(valor) {
      this.$emit('update:pesquisa', valor)
    },
    onExportar() {
      this.$emit('exportar')
    },
    onImportar() {
      this.$emit('importar')
    },
    onCadastrar() {
      this.$emit('cadastrar')
    }
  }
}
</script>

<style scoped>
.input-button.input-cinza {
  background-color: #f5f5f5;
}

.new-button {
  text-transform: none;
  font-weight: 500;
}

.brt-15 {
  border-radius: 15px;
}
</style>